import { CardProps, Card as MUICard } from '@mui/material';

// Basic wrapper around the mui card so we easily can control the styling in the future if we want to change it
export default function Card({ ...props }: CardProps) {
    return <MUICard elevation={1} {...props} />;
}
